import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../components/components.module';
import { MatIconModule } from '@angular/material/icon';

// Components
import { RvSortableComponent } from './components/rv-sortable/rv-sortable.component';
import { RvSortableHandleComponent } from './components/rv-sortable-handle/rv-sortable-handle.component';

// Directives
import { RvSortableItemDirective } from './directives/rv-sortable-item.directive';

@NgModule({
  declarations: [
    RvSortableComponent,
    RvSortableHandleComponent,
    RvSortableItemDirective,
  ],
  imports: [CommonModule, ComponentsModule, MatIconModule],
  exports: [
    RvSortableComponent,
    RvSortableHandleComponent,
    RvSortableItemDirective,
  ],
  providers: [
    // RvSortableService is not provided here as it's instantiated directly in components
  ],
})
export class RvSortableModule {}
